import cx from 'classnames'
import { useContext, useMemo } from 'react'

import { getLineItemsWithFrameBuilderDetails } from '@frame-builder/lib/cart'
import { CartContext } from '@lib/cart/context'
import { useRemoveItemFromCart, useUpdateCartItem } from '@lib/cart/hooks'
import { type LineItem } from '@lib/cart/types'
import { getLineItemsWithCombinedListingDetails } from '@lib/product/combined-listing/cart'

import CartEmpty from './empty'
import CartLineItem from './line-item'

interface CartItemsProps {
  lineItems: LineItem[]
  className?: string
  itemClassName?: string
}

const CartLineItems = ({
  lineItems,
  className,
  itemClassName,
}: CartItemsProps) => {
  const { toggleCart } = useContext(CartContext)

  const updateCartItem = useUpdateCartItem()
  const removeItemFromCart = useRemoveItemFromCart()

  const lineItemsWithDetails = useMemo(() => {
    let newLlineItems = [...lineItems]
    newLlineItems = getLineItemsWithCombinedListingDetails(newLlineItems)
    newLlineItems = getLineItemsWithFrameBuilderDetails(newLlineItems)

    return newLlineItems
  }, [lineItems])

  if (lineItemsWithDetails.length === 0) {
    return <CartEmpty />
  }

  return (
    <div className={cx('flex flex-col gap-y-5', className)}>
      {lineItemsWithDetails.map((lineItem) => (
        <CartLineItem
          key={lineItem.lineId}
          lineItem={lineItem}
          onUpdateItem={(lineId, quantity) => {
            updateCartItem([lineId], quantity)
          }}
          onRemoveItem={(lineId) => {
            removeItemFromCart([lineId])
          }}
          onClose={() => toggleCart(false)}
          className={itemClassName}
        />
      ))}
    </div>
  )
}

export default CartLineItems
